// @ts-nocheck
import styled from 'styled-components';

type Props = {
  backupsDataDisclaimerEnabled: boolean;
};

export const CampaignsStyle = styled.section<Props>`
  all: initial;
  background: linear-gradient(243.22deg, #202939 0%, #222C3D 100%);
  box-shadow: 0 2px 36px -4px rgba(18,22,30,0.16);
  display: flex;
  justify-content: center;
  width: 100%;
  transition: all linear 250ms;

  .reportingCampaigns {
    &__container {
      width: 100%;
      padding: 1rem 0.625rem;
    }
  }

  @media (min-width: 90rem) {
    .reportingCampaigns {
      &__container {
        max-width: 90rem;
      }
    }
    .reportingCampaignListContainer{
      &__wrapperSwitch {
        max-width: 90rem;
      }
      &__wrapperTable {
        max-width: 90rem;
      }
    }
  }

  @media (min-width: 100rem) {
    .reportingCampaigns {
      &__container {
        max-width: 100rem;
      }
    }
    .reportingCampaignListContainer{
      &__wrapperSwitch {
        max-width: 100rem;
      }
      &__wrapperTable {
        max-width: 100rem;
      }
    }
  }

  @media (min-width: 120rem) {
    .reportingCampaigns {
      &__container {
        max-width: 120rem;
      }
    }
    .reportingCampaignListContainer{
      &__wrapperSwitch {
        max-width: 120rem;
      }
      &__wrapperTable {
        max-width: 120rem;
      }
    }
  }

`;
